export const formatDateDdMmYyyy = (dateStr?: string): string => {
  if (!dateStr) return ''

  const isoDate = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoDate) {
    return `${isoDate[3]}-${isoDate[2]}-${isoDate[1]}`
  }

  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return dateStr

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const formatDateTime = (dateStr: string): string => {
  const date = new Date(dateStr)

  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'short' })
  const year = date.getFullYear()

  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')

  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`
}
